<script lang="ts" setup></script>

<template>
  <div class="px-5">
    <slot></slot>
  </div>
</template>
<style></style>
